import { ChangeDetectorRef, Component, ElementRef, Renderer2, ViewContainerRef } from '@angular/core';
import { Utils } from 'sharedFeatures/utils';
import { PopupComponent } from "sharedFeatures/window";
import { DomSmallUtils } from 'sharedGuiSmall/utils/dom-utils';
import { SharedGuiSmallModule } from '../../../../../sharedGuiSmall/sharedGuiSmall.module';
import { SafeHtmlPipe } from '../../../../pipes/safehtml.pipe';

declare var jQuery: any;

@Component({
    selector: 'info-popup',
    templateUrl: './info-popup.component.html',
    styleUrls: ['./info-popup.component.less'],
    standalone: true,
    imports: [SharedGuiSmallModule, SafeHtmlPipe]
})
export class InfoPopup extends PopupComponent {
    arrowTop = '50%';
    titleText: string = '';
    bodyText: string = '';
    pointer: string = 'right';
    showClose = false;

    isBusinessDoctors: boolean = false;
    constructor(element: ElementRef,
                r: Renderer2,
                viewContainerRef: ViewContainerRef,
                chDet: ChangeDetectorRef) {

        super(element, r, viewContainerRef, chDet);

        this.width = -1;
        this.height = -1;

        this.cornerRadius = 10;

        this.isModal = false;

        this.r.setStyle(this.getElDom(), 'zIndex', jQuery.topZIndex(Utils.zIndexSelector) + 1);

        this.isBusinessDoctors = (String)(window['isBusinessDoctors']).toLowerCase() === 'true';
    }

    public setTitleText(txt: string): void {
        this.titleText = txt;
        this.chDet.detectChanges();
    }

    public setBodyText(txt: string): void {
        this.bodyText = txt;
        this.chDet.detectChanges();
    }

    public showForPoint(x: number, y: number): void {
        const leftPaddingFromTargetElem = 20;
        const rightPaddingFromTargetElem = 38;
        const arrowHalfHeight = 10;

        if (this.pointer === 'right' && (x - leftPaddingFromTargetElem - DomSmallUtils.outerWidth(this.getElDom())) < 0) this.pointer = 'left';
        else if (this.pointer === 'left' &&
            ((x + rightPaddingFromTargetElem + DomSmallUtils.outerWidth(this.getElDom()) > document.body.offsetWidth) ||
            (x - leftPaddingFromTargetElem - DomSmallUtils.outerWidth(this.getElDom()) > 0))) this.pointer = 'right';

        const height = DomSmallUtils.outerHeight(this.getElDom());
        let top = y - height / 2;
        if (top < 0) top = 0;
        if (top > document.body.offsetHeight - DomSmallUtils.outerHeight(this.getElDom()))
            top = document.body.offsetHeight - DomSmallUtils.outerHeight(this.getElDom());

        let arrowTop = y;
        const topLimit = top + arrowHalfHeight;
        const downLimit = top + height - arrowHalfHeight;

        if (arrowTop < topLimit) arrowTop = topLimit;
        if (arrowTop > downLimit) arrowTop = downLimit;

        if (this.pointer === 'right') this.show(x - leftPaddingFromTargetElem - DomSmallUtils.outerWidth(this.getElDom()), top);
        else this.show(x + rightPaddingFromTargetElem, top);

        this.arrowTop = arrowTop - top + 'px';
    }
}
